import React, { useState, useEffect } from 'react';
import { Box, Button, FormControl, TextField, Typography } from "@mui/material";
import LayersClearIcon from '@mui/icons-material/LayersClear';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import styles from "../styles";

/**
 * A component that allows users to input and update a description.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.description - The current description value.
 * @param {function} props.updateDescription - A function to update the description value.
 * @param {function} props.redrawFretboard - A function to redraw the fretboard.
 * @param {boolean} props.viewer - A flag indicating if the user is a viewer.
 * @param {function} props.removeAllSelectedFrets - A function to remove all selected frets.
 * @returns {JSX.Element} The DescriptionInput component.
 */
const DescriptionInput = ({ description, updateDescription, redrawFretboard, viewer, removeAllSelectedFrets }) => {
    const [textareaContent, setTextareaContent] = useState(description ? description : '');
    const [showDescription, setShowDescription] = useState(false);

    const handleUpdateText = (event) => {
        setTextareaContent(event.target.value);
        updateDescription(event.target.value);
    };

    const handleCloseButton = () => {
        setShowDescription(false);
        redrawFretboard();
    }

    //add an effect to update the textareaContent when the description changes
    useEffect(() => {
        setTextareaContent(description);
    }, [description]);

    return (
        <Box style={{ display: 'flex', flexDirection: 'row', paddingY: '5px' }}>
            {!viewer &&
                <>
                    {!showDescription ? (
                        <Box style={{ display: 'flex', flexDirection: 'row' }}>
                            <Button
                                id="description-button"
                                aria-controls={'button'}
                                aria-haspopup="true"
                                onClick={() => setShowDescription(true)}
                                variant="outlined"
                                size="small"
                                sx={{ marginRight: "5px" }}
                                startIcon={textareaContent !== '' ? <EditIcon /> : <AddIcon />}
                            >
                                Description
                            </Button>
                        </Box>
                    ) : (
                        <Box style={{ display: 'flex', flexDirection: 'row' }}>
                            <TextField
                                id="standard-basic"
                                variant="standard"
                                defaultValue={textareaContent}
                                onChange={(event) => handleUpdateText(event)}
                            />
                            <Button size="small" variant="outlined" onClick={() => handleCloseButton()}>Close</Button>
                        </Box>
                    )}
                </>
            }
            <Button id="button-clear" variant="outlined" onClick={() => removeAllSelectedFrets()} size="small" startIcon={<LayersClearIcon />}>Clear</Button>
        </Box >
    );
};

export default DescriptionInput;
